module.exports = __webpack_public_path__ + "img/企业介绍_价值观.add946ab.png";